import { useQuery } from '@tanstack/react-query';

import useUrl from '~/common/hooks/useUrl';
import { typedApiClient } from '~/common/util/api-client';

export default function useBoltStatus() {
  const { obfuscatedLoanIdentifier } = useUrl();

  return useQuery({
    queryKey: ['boltStatus'],
    async queryFn() {
      const { data } = await typedApiClient.v1.boltStatusGetBoltStatus({
        obfuscatedLoanIdentifier,
      });
      return data;
    },
    select(data) {
      const { isLoanZapped, isTestLoan, userCanImpersonate } = data;
      return {
        isLoanSubmitted: data.completionStatusIND,
        isLoanZapped,
        userCanImpersonate,
        isTestLoan,
      };
    },
    placeholderData: {},
    enabled: !!obfuscatedLoanIdentifier,
    staleTime: Infinity,
  });
}
